export default __webpack_public_path__ + "static/media/calendar.56e828cf.svg";